(function () {
  function initVideoGallery(root) {
    if (!root || root.dataset.vdgInitialized === 'true') return;
    root.dataset.vdgInitialized = 'true';

    var lightbox = root.querySelector('[data-vdg-lightbox]');
    var lightboxMedia = root.querySelector('[data-vdg-lightbox-media]');
    if (!lightbox || !lightboxMedia) return;

    var closers = root.querySelectorAll('[data-vdg-lightbox-close]');
    var playButtons = root.querySelectorAll('[data-vdg-play]');
    var lastFocused = null;

    function closeLightbox() {
      lightbox.hidden = true;
      lightboxMedia.innerHTML = '';
      document.body.classList.remove('vdg-lightbox-open');
      if (lastFocused) lastFocused.focus();
    }

    function openLightbox(card) {
      var template = card.querySelector('[data-vdg-template]');
      if (!template) return;

      lastFocused = document.activeElement;
      lightboxMedia.innerHTML = '';
      lightboxMedia.appendChild(template.content.cloneNode(true));
      lightbox.hidden = false;
      document.body.classList.add('vdg-lightbox-open');

      var video = lightboxMedia.querySelector('video');
      if (video) video.play().catch(function () {});

      var closeBtn = root.querySelector('[data-vdg-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }

    playButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('.vdg__card');
        if (card) openLightbox(card);
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  function initAll(context) {
    (context || document).querySelectorAll('.vdg').forEach(initVideoGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
